module.exports = __webpack_public_path__ + "static/media/ssw13.16d22fcc.png";